export default {"src":"/_next/static/media/store-alt.5b873c33.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};